module.exports = __webpack_public_path__ + "static/media/flyers.8abd8e33.webp";